import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import { onDestroy } from 'svelte';

import {
	getLanguage,
	getLanguageLabel,
	setLanguage,
	subscribeLanguageChange,
	t
} from '../i18n.ts';

import Button from './svelte-button.svelte';

var root = $.from_html(`<div class="header-language-switcher svelte-km0orx" role="group"><!> <!></div>`);

const $$css = {
	hash: 'svelte-km0orx',
	code: '.header-language-switcher.svelte-km0orx {display:inline-flex;align-items:center;gap:6px;}.button.language-button {width:32px;min-width:32px;height:32px;padding:0;border-radius:999px;text-transform:lowercase;}'
};

export default function Svelte_language_switcher($$anchor, $$props) {
	$.push($$props, true);
	$.append_styles($$anchor, $$css);

	function dispatch(eventName, detail) {
		$$props.$$host.dispatchEvent(new CustomEvent(eventName, { detail, bubbles: true, composed: true }));
	}

	let language = $.state($.proxy(getLanguage()));

	const disposeLanguageSync = subscribeLanguageChange((nextLanguage) => {
		$.set(language, nextLanguage, true);
	});

	function isLanguage(value) {
		return value === 'ja' || value === 'en';
	}

	function handleLanguageSelect(nextLanguage) {
		if (!isLanguage(nextLanguage)) {
			dispatch('status-message', {
				message: t('header.status.invalidLanguageSelection', { value: String(nextLanguage) }),
				kind: 'error'
			});

			return;
		}

		if (nextLanguage === $.get(language)) {
			return;
		}

		setLanguage(nextLanguage);
	}

	function tr(key, values) {
		$.get(language);

		return values ? t(key, values) : t(key);
	}

	onDestroy(() => {
		disposeLanguageSync();
	});

	var div = root();
	var node = $.child(div);

	{
		let $0 = $.derived(() => $.get(language) === 'en');
		let $1 = $.derived(() => tr('language.switchAria', { language: getLanguageLabel('en') }));
		let $2 = $.derived(() => $.get(language) === 'en' ? 'true' : 'false');

		Button(node, {
			type: 'button',
			variant: 'secondary',
			get active() {
				return $.get($0);
			},
			className: 'language-button',
			id: 'btn-set-language-en',
			get ariaLabel() {
				return $.get($1);
			},

			get ariaPressed() {
				return $.get($2);
			},
			handlePress: () => handleLanguageSelect('en'),
			children: ($$anchor, $$slotProps) => {
				$.next();

				var text = $.text('en');

				$.append($$anchor, text);
			},
			$$slots: { default: true }
		});
	}

	var node_1 = $.sibling(node, 2);

	{
		let $0 = $.derived(() => $.get(language) === 'ja');
		let $1 = $.derived(() => tr('language.switchAria', { language: getLanguageLabel('ja') }));
		let $2 = $.derived(() => $.get(language) === 'ja' ? 'true' : 'false');

		Button(node_1, {
			type: 'button',
			variant: 'secondary',
			get active() {
				return $.get($0);
			},
			className: 'language-button',
			id: 'btn-set-language-ja',
			get ariaLabel() {
				return $.get($1);
			},

			get ariaPressed() {
				return $.get($2);
			},
			handlePress: () => handleLanguageSelect('ja'),
			children: ($$anchor, $$slotProps) => {
				$.next();

				var text_1 = $.text('ja');

				$.append($$anchor, text_1);
			},
			$$slots: { default: true }
		});
	}

	$.reset(div);
	$.template_effect(($0) => $.set_attribute(div, 'aria-label', $0), [() => tr('header.languageGroupAria')]);
	$.append($$anchor, div);
	$.pop();
}

customElements.define('lut-language-switcher', $.create_custom_element(Svelte_language_switcher, {}, [], []));